import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { MeResponse, UpdateProfileRequest } from '@seo/types';
import { apiPatch } from '@/lib/api';
import { useAuthStore } from '@/lib/auth';

/**
 * Mutate PATCH /v1/me. The API returns the full `MeResponse` so we can
 * patch the auth store in one step (no follow-up GET needed).
 */
export function useUpdateProfile() {
  const qc = useQueryClient();
  const patchUser = useAuthStore((s) => s.patchUser);
  return useMutation({
    mutationFn: (input: UpdateProfileRequest) =>
      apiPatch<MeResponse>('/v1/me', input),
    onSuccess: (data) => {
      patchUser({
        display_name: data.user.display_name,
        email: data.user.email,
      });
      void qc.invalidateQueries({ queryKey: ['me'] });
    },
  });
}
